import angular from 'angular';

import EventValueKeyFilterModule from './event-value-key-filter';

export default angular
    .module('application.component.modals.component.event-edit-modal.directive', [
        EventValueKeyFilterModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-edit-modal/directive/index.js